import React, {
  forwardRef,
} from 'react';
import { ReportPdfProps } from '../taiReportingSystem/utils/types';
import { getPageMargins } from '../ScreenReportPdf/constant';
import ExpenseComponentToPrint from './ExpenseComponentToPrint';

function ExpenseReportPdf({ printRef }:ReportPdfProps) {
  const pageMarginsCSS = getPageMargins;

  return (
    <>
      <style>{pageMarginsCSS}</style>
      <div style={{
        display: 'none', width: '900px', margin: '0 auto', backgroundColor: '#FFFFFF',
      }}
      >
        <ExpenseComponentToPrint ref={printRef} />
      </div>
    </>
  );
}

const ScreenExpenseReportPdf = forwardRef(ExpenseReportPdf);

export default ScreenExpenseReportPdf;
